import script from "./PlansAdvantage.vue?vue&type=script&setup=true&lang=js"
export * from "./PlansAdvantage.vue?vue&type=script&setup=true&lang=js"

import "./PlansAdvantage.vue?vue&type=style&index=0&id=3e4e3fd4&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e4e3fd4"]])

export default __exports__